import React, { Component } from 'react';
//import { history } from "../../store/store";
//import _ from "lodash";
import ProjectsLayout from '../../templates/project';
import ConclusionEditForm from '../../elements/project/conclusion';
import Loading from "../../elements/loading";

class ProjectConclusion extends Component {
	render (){
		let { project } = this.props;
		return (
			project.conclusion.isFetching ? <Loading message="Cargando Conclusión..." /> :
				<ConclusionEditForm
					conclusion={project.conclusion}
					version={project.version}
					permissions={project.permissions}
					projectConclusionExport={this.props.projectConclusionExport}
					match={this.props.match}
					history={this.props.history}
					projectConclusionSave={this.props.projectConclusionSave}/>
		);
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;
		this.props.projectConclusion(modality, state, municipality);
	}

	componentWillReceiveProps(newprops) {
		let { modality, state, municipality } = newprops.match.params;
		if(newprops.location.pathname !== this.props.location.pathname) {
			this.props.projectConclusion(modality, state, municipality);
		}
	}
}

export default ProjectsLayout(ProjectConclusion, {subnav: 6});


// WEBPACK FOOTER //
// ./src/layouts/project/conclusion.jsx